import React, { Component } from 'react';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".styles_container__2pRR5 {\n  width: 100%;\n  position: fixed;\n  top: 0;\n}\n\n.styles_intermittent__2ztC7 {\n  position: relative;\n  max-width: 100%;\n  height: 100%;\n  transition: all 300ms ease-in-out 1s;\n}\n\n.styles_continues__3Yx6D {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  animation: styles_continuesAnim__mUIxe 1.5s infinite ease-out;\n}\n\n@keyframes styles_continuesAnim__mUIxe {\n  0% {\n    left: -100%;\n    width: 100%;\n  }\n  100% {\n    left: 100%;\n    width: 70%;\n  }\n}\n";
var styles = { "container": "styles_container__2pRR5", "intermittent": "styles_intermittent__2ztC7", "continues": "styles_continues__3Yx6D", "continuesAnim": "styles_continuesAnim__mUIxe" };
styleInject(css);

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var isNum = function isNum(num) {
  return typeof num === 'number';
};

var LinearLoader = function (_Component) {
  inherits(LinearLoader, _Component);

  function LinearLoader() {
    classCallCheck(this, LinearLoader);
    return possibleConstructorReturn(this, (LinearLoader.__proto__ || Object.getPrototypeOf(LinearLoader)).apply(this, arguments));
  }

  createClass(LinearLoader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          progress = _props.progress,
          height = _props.height,
          backgroundColor = _props.backgroundColor,
          color = _props.color,
          containerStyle = _props.containerStyle,
          style = _props.style;


      return React.createElement(
        'div',
        {
          className: styles.container,
          style: _extends({ height: height, backgroundColor: backgroundColor }, containerStyle)
        },
        isNum(progress) ? React.createElement('div', {
          className: styles.intermittent,
          style: _extends({ width: progress + '%', backgroundColor: color }, style)
        }) : React.createElement('div', {
          className: styles.continues,
          style: _extends({ backgroundColor: color }, style)
        })
      );
    }
  }]);
  return LinearLoader;
}(Component);

LinearLoader.defaultProps = {
  height: '5px',
  backgroundColor: '#cdffeb',
  color: '#009f9d',
  containerStyle: {},
  style: {}
};

export default LinearLoader;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 18
// module chunks = 0